<script>
export default {
  props: {
    nome: String,
    cardColor: String,
    velorio: String,
    capela: String,
    sepultamento: String,
    cemiterio: String,
    falecimento: String,
    nascimento: String,
    empresaVelorio: String,
  },
  methods: {
    formatarHora(valor) {
      const [, hora] = valor.split(" ");
      if (hora == "00:00") {
        return "NÃO DEFINIDO";
      }
      return hora;
    },
    formatarData(horario) {
      const [data] = horario.replace("-", "/").replace("-", "/").split(" ");
      return data;
    },
    velorioVirtual() {
      this.$router.push({
        path: "/velorios",
        query: { empresaQuery: this.empresaVelorio },
      });
    },
  },
};
</script>

<template>
  <div class="card" :style="{ backgroundColor: cardColor }">
    <div class="card-content">
      <div style="text-align: left">
        <v-chip outlined
          ><v-icon class="recording-icon">mdi mdi-access-point</v-icon>AO
          VIVO</v-chip
        >
      </div>

      <p
        style="
          font-size: 20px;
          font-weight: 700;
          margin: 4px auto 36px;
          height: 2.4rem;
        "
      >
        <span v-if="nome && nome.length > 37">
          {{ nome.toUpperCase() }}...
        </span>
        <span v-else>
          {{ nome.toUpperCase() }}
        </span>
      </p>

      <div class="card-icon">
        <i class="fas fa-solid fa-star white-icon"></i>
        <p>{{ formatarData(nascimento) }}</p>
        <i class="fas fa-cross card-icon white-icon"></i>
        <p>{{ formatarData(falecimento) }}</p>
      </div>

      <div class="card-section">
        <div class="card-section-title">
          <p>Velório</p>
          <p v-if="velorio != 'NÃO INFORMADO'">
            Horário: {{ formatarData(velorio) }} - {{ formatarHora(velorio) }}
          </p>
          <p v-else>Horário: NÃO DEFINIDO</p>
          <p v-if="capela != 'NÃO INFORMADO'">Local: {{ capela }}</p>
          <p v-else>Local: NÃO DEFINIDO</p>
        </div>
        <div class="card-section-title">
          <p>Sepultamento</p>
          <p>
            Horário: {{ formatarData(sepultamento) }} -
            {{ formatarHora(sepultamento) }}
          </p>
          <p>Cemitério: {{ cemiterio }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.recording-icon {
  animation: blink 2s infinite;
  font-size: 1.4rem;
  margin-right: 0.2rem;
}
@keyframes blink {
  0%,
  100% {
    color: red;
  }

  50% {
    color: white;
  }
}

* {
  margin: 0;
}

button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.card-content {
  color: white;
  padding: 4px;
  display: flex;
  flex-direction: column;
}

.card {
  display: inline-block;
  width: 20rem;
  height: 24rem;
  border-radius: 5px;
  text-align: center;
  padding: 0 1rem;
}

.card-icon {
  font-size: 18px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.card-icon p:first-of-type {
  margin-right: 1rem;
}

.white-icon {
  color: white;
}

.card-section-title {
  margin-top: 4px;
}

.card-section-title p {
  font-size: 16px;
}

.card-image {
  width: 100px;
  height: 100px;
  margin: 10px auto;
}

.card-content {
  color: white;
  padding: 5px;
}

.card-section-title p:first-of-type {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 6px;
}

.card-section-title:last-child {
  margin-top: 1rem;
}

@media screen and (max-width: 815px) {
  .card {
    width: 90%;
  }
}
</style>
